module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "pageHeaderContainer"
  }, [_c('p', {
    staticClass: "projectSubTittle",
    class: _vm.projectName
  }, [_vm._v(_vm._s(_vm.renderText(_vm.page.subTitle)))]), _c('h2', {
    staticClass: "projectTitle"
  }, [_vm._v(_vm._s(_vm.renderText(_vm.page.title)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01fa9603!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/about/header.vue
// module id = 88
// module chunks = 1